export const RFTfeature = () => {
  const companyCode = localStorage.getItem("companyCode");
  const companies = [4888];

  let found = companies.find((item) => item == companyCode);
  if (found) {
    return true;
  } else {
    false;
  }
};
